import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, CalendarDays, Megaphone } from "lucide-react";
import api from "../../api/api";

const heroBg = "/assets/images/bg2.jpeg";

export default function AnnouncementSingle() {
  const { slug } = useParams();
  const [announcement, setAnnouncement] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const res = await api.get(`/announcements/single/${slug}`);
        setAnnouncement(res.data);
      } catch (error) {
        console.error("Failed to fetch announcement:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAnnouncement();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center font-bold text-slate-500">
        Loading announcement...
      </div>
    );
  }

  if (!announcement) {
    return (
      <div className="min-h-screen flex items-center justify-center text-center px-5">
        <div>
          <h1 className="text-3xl font-black text-[#061A40]">
            Announcement not found
          </h1>

          <Link
            to="/publications/announcements"
            className="mt-6 inline-flex text-[#061A40] font-bold"
          >
            Back to Announcements
          </Link>
        </div>
      </div>
    );
  }

  return (
    <main className="bg-white">
      <section
        className="relative min-h-[420px] flex items-center bg-cover bg-center"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="absolute inset-0 bg-[#061A40]/85" />

        <div className="relative z-10 max-w-5xl mx-auto px-5 py-24 text-white">
          <Link
            to="/publications/announcements"
            className="inline-flex items-center gap-2 text-[#F4B000] font-black mb-6"
          >
            <ArrowLeft size={18} />
            Back to Announcements
          </Link>

          <p className="uppercase tracking-[0.35em] text-[#F4B000] font-black text-xs">
            Official Announcement
          </p>

          <h1 className="text-4xl md:text-6xl font-black mt-4 leading-tight">
            {announcement.title}
          </h1>

          <div className="mt-6 flex flex-wrap items-center gap-4 text-white/75">
            {announcement.category?.name && (
              <span className="inline-flex items-center gap-2">
                <Megaphone size={18} />
                {announcement.category.name}
              </span>
            )}

            {announcement.published_at && (
              <span className="inline-flex items-center gap-2">
                <CalendarDays size={18} />
                {new Date(announcement.published_at).toLocaleDateString()}
              </span>
            )}
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-4xl mx-auto px-5">
          {announcement.summary && (
            <div className="bg-[#F4B000]/10 border-l-4 border-[#F4B000] p-6 rounded-2xl mb-10">
              <p className="text-lg font-semibold text-[#061A40] leading-8">
                {announcement.summary}
              </p>
            </div>
          )}

          <article
            className="prose prose-lg max-w-none prose-headings:text-[#061A40] prose-a:text-[#061A40]"
            dangerouslySetInnerHTML={{ __html: announcement.content }}
          />
        </div>
      </section>
    </main>
  );
}